import { analytics } from '@silvertours/front-entities';
import { Ui } from '@silvertours/front-shared';
import type { LoginTranslations } from './LoginForm';

type Props = {
  translations: LoginTranslations;
  isLoggedIn: boolean;
};

const Footer = ({
  translations: { newUserHref, newUserText, noAccountText },
  isLoggedIn,
}: Props) => (
  <>
    {noAccountText}{' '}
    <Ui.TextLink
      href={newUserHref}
      text={newUserText}
      onClick={() => analytics.gtm.trackNewUser({ isLoggedIn })}
    />
  </>
);

export { Footer };
